import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  flex: 1;
  width: 48px;
  height: 48px;
  // padding: 0;
  // border: 1px solid ${({ filled }) => (filled ? '#6FCF97' : '#E3E3E3')};
  border: 1px solid #d2d3dd;
  border-radius: 12px;
  text-align: center;
  margin: 0 0.7rem;
  font-size: 1.25rem;
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

const OtpInput = ({ onComplete, onChange }) => {
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputsRef = useRef([]);

  // Focus first input on mount
  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  // Handle input change
  const handleChange = (val, idx) => {
    if (!/^\d*$/.test(val)) return; // allow only digits
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);

    // ✅ Call the onChange prop with the joined OTP
    onChange?.(newOtp.join(''));

    if (val && idx < 3) {
      inputsRef.current[idx + 1]?.focus();
    }

    if (newOtp.every((digit) => digit.length > 0)) {
      onComplete?.(newOtp.join(''));
    }
  };

  // Handle backspace key for navigation
  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !otp[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  return (
    <InputContainer>
      {otp.map((val, idx) => (
        <StyledInput
          key={idx}
          type="tel"
          maxLength={1}
          value={val}
          filled={val.length > 0}
          onChange={(e) => handleChange(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          ref={(el) => (inputsRef.current[idx] = el)}
        />
      ))}
    </InputContainer>
  );
};

export default OtpInput;
